// src/api/login.js
import api from './axiosInstance';                 // axios 인스턴스, 기본 설정된 HTTP 클라이언트
import { fetchCsrfToken } from './csrf';           // CSRF 토큰을 요청하는 함수
import { setAccessToken } from './axiosInstance';  // accessToken을 메모리에 저장하는 함수

/**
 * 로그인 처리 함수
 * @param {Object} loginData - 로그인 요청에 필요한 사용자 정보 (예: { userId, password })
 * @returns {Object} - { accessToken, message } 로그인 성공 시 토큰과 메시지 반환
 * 
 * 동작 흐름:
 * 1. 로그인 API 호출 (쿠키를 포함하여)
 * 2. 응답에서 accessToken 추출 후 메모리에 저장
 * 3. CSRF 토큰을 별도 요청하여 보안 강화
 * 4. 성공 시 accessToken과 메시지 반환
 * 5. 실패 시 에러를 호출부로 던짐
 */
export const loginUser = async (loginData) => {
  console.log('[Login] 🔐 로그인 시도:', loginData);

  try {
    // 1. 로그인 API 호출 (withCredentials: true -> 쿠키 전송 포함)
    const response = await api.post('/api/login', loginData, { withCredentials: true });
    console.log('[Login] ✅ 로그인 응답:', response);

    // 2. 응답 데이터에서 accessToken과 메시지 추출
    const accessToken = response.data?.data?.accessToken;
    const message = response.data?.message || '로그인 성공';

    // 3. accessToken이 없으면 경고 로그 출력 후 에러 발생
    if (!accessToken) {
      console.warn('[Login] ⚠️ 로그인 응답에 accessToken 없음');
      throw new Error('로그인 응답에 accessToken 없음');
    }

    // 4. accessToken을 메모리에 저장 (axiosInstance 등에서 사용)
    setAccessToken(accessToken);
    console.log('[Login] ✅ accessToken 메모리에 저장 완료:', accessToken);

    // 5. CSRF 토큰 요청 (로그인 이후 보안 토큰 갱신 목적)
    console.log('[Login] 🔐 CSRF 토큰 요청 시작...');
    // await fetchCsrfToken();
    console.log('[Login] ✅ CSRF 토큰 요청 완료');

    // 6. accessToken과 메시지 반환
    return { accessToken, message };
  } catch (error) {
    // 로그인 과정에서 에러 발생 시 로그 출력 후 다시 에러 던짐
    console.error('[Login] ❌ 로그인 실패:', error);
    throw error;
  }
};
